module.exports = __webpack_public_path__ + "static/media/vending-machine.6ffad98b.png";